export class SubHeaderData {
    displayText: string;
    displayTitle: string;
    defaultImageSrc: string;
    mouseOverImageSrc: string;
    disableActions: boolean;
    isGeneralSettings: boolean;
    generalTabIndex: number;
    isInstanceSettings: boolean;
    isIdmsSettings?: boolean;
    isCdmsSettings?: boolean;
}
